module.exports = __webpack_public_path__ + "img/rackspace-logo.b394b503.png";